import React, { FC, ReactNode, useEffect, useState } from 'react';
import {
  Filter,
  FilterQmOperatorsType,
  FilterRangeParametersItemForLType,
  FilterRangeParametersItemForRType,
  FilterRangeType,
  FilterUcid,
  KeysForFilteringType,
  Range,
} from '@app/components/ui/easy-filter/types';

import { OptionItem } from '@app/components/ui/select/select.type';
import { UniversalFilterConstants } from '@app/hooks/use-filter-data';

import { Button, EasyModal } from '@ui';

import { ChevronDownIcon } from '@icons';

import { useIsOverflow } from '@app/hooks/use-overflow';

import useTranslation from '@app/hooks/use-translation';

import { onFilterInput } from '@app/components/ui/easy-filter/helpers';

import moment from 'moment';

import EasyFilter from './easy-filter';
import FilterSearch, { SelectsDataType } from './blocks/filter-search';
import FilterViewInput from './blocks/filter-view-input';
import ModalModeFilterView from './blocks/modal-mode-filter-view';
type EasyFilterProps = {
  data?: Filter & Range & Partial<FilterQmOperatorsType> & FilterUcid;
  footerMarkup?: ReactNode;
  titleMarkup?: ReactNode;
  keysForFiltering: KeysForFilteringType[];
  fillFromTemplate?: boolean;
  onChangeHandler(data: Filter & Range & FilterUcid & Partial<FilterQmOperatorsType>): void;
  disabledChangeButton?: boolean;
  isLoading?: boolean;
  modalMode?: boolean;
  modalModeStyle?: 'first' | 'second';
  disableSearch?: boolean;
  disableSaveButton?: boolean;
  withoutCallId?: boolean;
  dataIdStartDate?: string;
  dataIdEndDate?: string;
  customFilterLabel?: string;
  filterWithSearch?: boolean;
  withoutRange?: boolean;
  handleSubmitSearchWithFilter?(data: any): void;
  handleChangeSearchVisibilityState?(state: boolean): void;
  handleResetSearch?(): void;
  selects?: SelectsDataType[];
  teamsAndOperatorsDataForFilter?: Record<'qm_teams' | 'qm_operators', OptionItem[]>;
};
const EasyFilterView: FC<EasyFilterProps> = (props) => {
  const { t } = useTranslation('components.filter');
  const {
    metaDateTime,
    // metaDateTimeCalendar,
    metaDateTimeCalendarForRangeShow,
    metaDateTimeCalendarId,
    metaDateTimeForRangeShow,
  } = UniversalFilterConstants();
  const {
    data = {
      range: {
        type: getRangeSelectOptions()[0].value as FilterRangeType,
        parameters: [],
      },
      filter: [],
      operators: [],
      ucid: undefined,
    },
    modalMode = false,
    customFilterLabel: customFilterLabel,
    footerMarkup,
    titleMarkup,
    keysForFiltering,
    fillFromTemplate = false,
    isLoading,
    onChangeHandler,
    teamsAndOperatorsDataForFilter,
    disableSaveButton,
    disabledChangeButton,
    dataIdStartDate,
    withoutCallId,
    dataIdEndDate,
    withoutRange = false,
    filterWithSearch = false,
    handleSubmitSearchWithFilter,
    selects,
    handleResetSearch,
    handleChangeSearchVisibilityState,
    disableSearch,
    modalModeStyle = 'first',
  } = props;

  const valueClassName = 'bg-defaultBg px-[8px] pt-[2px] pb-[3px] rounded-[4px]';
  // const [calendarBindValue, changeCalendarBindValue] = useState(metaDateTimeCalendar[0].id);
  const [filterData, changeFilterData] = useState(data);

  const [filterOpenState, changeFilterOpenState] = useState(false);
  const [filterFullHeight, changeFilterFullHeightState] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const [filterViewRef, setFilterViewRef] = useState<HTMLDivElement | null>(null);

  const renderRangeValues = {
    n: <></>,
    r: (
      <div className={'flex items-center w-full gap-[10px]'}>
        <div className={`flex gap-[5px] items-center ${valueClassName}`}>
          <div>{t('from')}</div>
          <div>
            {moment(
              (filterData.range.parameters[0] as FilterRangeParametersItemForRType)?.value,
            ).format('DD.MM.yyyy HH:mm')}
          </div>
        </div>
        <div>-</div>
        <div className={`flex items-center gap-[5px] ${valueClassName}`}>
          <div>{t('before')}</div>
          <div>
            {moment(
              (filterData.range.parameters[1] as FilterRangeParametersItemForRType)?.value,
            ).format('DD.MM.yyyy HH:mm')}
          </div>
        </div>
      </div>
    ),
    l: (
      <div className={'flex items-center gap-[5px]'}>
        <div className={valueClassName}>
          {(filterData.range.parameters[0] as FilterRangeParametersItemForLType)?.num}
        </div>
        <div>{t('days')}</div>
      </div>
    ),
    cd: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    cw: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    cm: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    cq: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    lq: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    ld: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    lw: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
    lm: (
      <div className="flex items-center gap-[10px]">
        <div>{metaDateTime.find((dateTime) => dateTime.id === metaDateTimeCalendarId)?.name}</div>
        <div className={valueClassName}>{metaDateTimeCalendarForRangeShow[data.range.type]}</div>
      </div>
    ),
  };
  function getRangeSelectOptions(): OptionItem[] {
    return metaDateTime.map((item) => ({ value: item.id, title: item.name }));
  }
  function onChangeFullHeightFilter() {
    changeFilterFullHeightState((prev) => !prev);
  }
  function changeFilterModalState() {
    changeFilterOpenState(true);
  }
  function getNameByValueKey(key: string) {
    return keysForFiltering.find((item) => item.id === key)?.title || 'N/A';
  }

  function onChangeFilter(data: Filter & Range & FilterUcid) {
    if (withoutCallId) {
      delete data['ucid'];
    }
    onChangeHandler(data);
    changeFilterData(data);
  }
  function onFillFromTemplateHandler(data: Filter & Range & FilterUcid) {
    if (withoutCallId) {
      delete data['ucid'];
    }
    changeFilterData(data);
    // onChangeHandler(data);
  }
  function handleSubmitSearch(object: { [x: string]: string }) {
    handleSubmitSearchWithFilter?.({ ...object, filter: filterData });
  }

  useIsOverflow(filterViewRef as HTMLElement, (isOverflow) => setOverflow(isOverflow));
  useEffect(() => {
    if (!data) return;
    changeFilterData(data);
  }, [data]);

  return (
    <>
      {modalMode ? (
        <ModalModeFilterView
          modalModeStyle={modalModeStyle}
          filterData={filterData}
          getNameByValueKey={getNameByValueKey}
          changeFilterModalState={changeFilterModalState}
          disabledChangeButton={disabledChangeButton || false}
        />
      ) : (
        <div className="pt-[20px] pb-[20px] pr-[25px] pl-[22px] bg-white border-l-[2px] border-l-speech_analitics rounded-xl">
          {titleMarkup && <div className="text-[18px] leading-[21px]">{titleMarkup}</div>}
          <div className={'flex w-full items-center gap-[6px] py-[15px] pb-[20px]'}>
            <div className={'text-[15px] leading-[18px]'}>
              {metaDateTimeForRangeShow[filterData.range.type]}
            </div>
            <div className={'text-[15px] leading-[18px]'}>
              {renderRangeValues[filterData.range.type]}
            </div>
          </div>

          <div className={'flex w-full'}>
            <div
              onDoubleClick={disabledChangeButton ? undefined : changeFilterModalState}
              className={
                'relative  pl-[19.34px] py-[4.5px] w-full bg-white border border-b_dark rounded-defaultR truncate mr-6'
              }
              style={{ height: filterFullHeight ? '100%' : '34px' }}
              ref={(ref) => setFilterViewRef(ref)}
            >
              <div
                style={{ width: 'calc(100% - 50px)' }}
                className={`flex flex-wrap gap-y-[10px] w-full px-2`}
              >
                <FilterViewInput filterData={filterData} getNameByValueKey={getNameByValueKey} />
                {/* TODO: Implement filter view input */}
              </div>
              {(overflow || filterFullHeight) && (
                <div
                  onClick={onChangeFullHeightFilter}
                  className={`absolute right-[8px] bottom-[6px] cursor-pointer p-[5px] bg-defaultBg rounded-[4px] ${
                    filterFullHeight && 'rotate-180'
                  }`}
                >
                  <ChevronDownIcon size={12} />
                </div>
              )}
            </div>
            <Button
              label={t('change')}
              fill="outlined"
              icon="Edit2Icon"
              className="self-start"
              disabled={disabledChangeButton}
              onClick={() => changeFilterModalState()}
            />
          </div>

          {(footerMarkup || filterWithSearch) && (
            <div className="pt-[25px] flex items-center w-full ">
              {footerMarkup ? footerMarkup : null}
              {filterWithSearch ? (
                <FilterSearch
                  handleResetSearch={handleResetSearch}
                  handleSubmitSearch={handleSubmitSearch}
                  handleChangeVisibilityState={handleChangeSearchVisibilityState}
                  selects={selects || []}
                  disableSearch={disableSearch}
                />
              ) : null}
            </div>
          )}
        </div>
      )}
      <EasyModal
        withoutFooter
        label={<div className={'pb-[30px]'}>{customFilterLabel || t('edit_filter')}</div>}
        withoutContentPadding
        show={filterOpenState}
        onClose={() => {
          changeFilterOpenState(false);
        }}
        variant={'largeW1127'}
      >
        {filterOpenState && (
          <EasyFilter
            modalMode={modalMode}
            isLoading={isLoading}
            withoutRange={withoutRange}
            // calendarBindValue={changeCalendarBindValue}
            data={onFilterInput(filterData)}
            onChange={(data) => onChangeFilter(data)}
            changeFilterOpenState={changeFilterOpenState}
            keysForFiltering={keysForFiltering}
            fillFromTemplate={fillFromTemplate}
            teamsAndOperatorsDataForFilter={teamsAndOperatorsDataForFilter}
            dataIdEndDate={dataIdEndDate}
            dataIdStartDate={dataIdStartDate}
            disable={disableSaveButton}
            withoutCallId={withoutCallId}
            fillFromTemplateHandler={onFillFromTemplateHandler}
          />
        )}
      </EasyModal>
    </>
  );
};

export default EasyFilterView;
